export const POWER_BANK_ACTIVE_LOADING = "POWER_BANK_ACTIVE/loading";
export const POWER_BANK_ACTIVE_ERROR = "POWER_BANK_ACTIVE/error";
export const POWER_BANK_ACTIVE_FILTERS = "POWER_BANK_ACTIVE/filters";
export const POWER_BANK_ACTIVE_LIST = "POWER_BANK_ACTIVE/list";
export const POWER_BANK_ACTIVE_ADD = "POWER_BANK_ACTIVE/add";
export const POWER_BANK_ACTIVE_UPDATE = "POWER_BANK_ACTIVE/update";
export const POWER_BANK_ACTIVE_DELETE = "POWER_BANK_ACTIVE/delete";
export const POWER_BANK_ACTIVE_FINISH = "POWER_BANK_ACTIVE/finish";



// WEBPACK FOOTER //
// ./src/actions/chargers/activeRent/constants.js